export const DBConfig = {
  name: "ERP",
  version: 2,
  objectStoresMeta: [
    {
      store: "appState",
      storeConfig: { keyPath: "id", autoIncrement: true },
      storeSchema: [
        { name: "auth", keypath: "auth" },
        { name: "resources", keypath: "resources" },
        { name: "settings", keypath: "settings" },
        { name: "hasChanged", keypath: "hasChanged" },
      ],
    },
  ],
};
